import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useField } from "formik";
import FieldErrorMessage from "./FieldErrorMessage";
import { getFieldId, getHelpTextId, useAddErrorClass } from "./utilities";
import classNames from "classnames";
import { NumericFormat, PatternFormat, } from "react-number-format";
import { getCurrencySymbol } from "core/util/currencySymbol";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
const Input = (props) => {
    const [field, , helper] = useField(props.name);
    const [value, setValue] = useState();
    let inputClassName = classNames([
        "form-control",
        props.className,
        { "form-control-wholenumber": props.type === "wholeNumber" },
        { "form-control-currency": props.type === "currency" },
        {
            "form-control-text": props.type === "text" ||
                props.type === "password" ||
                props.type === "bsb",
        },
    ]);
    inputClassName = useAddErrorClass(props.name, inputClassName);
    const helpTextId = props.helpText != null ? getHelpTextId(props.name) : undefined;
    const fieldId = getFieldId(props.name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const charallow = (e) => {
        setValue(e.target.value.replace(/[^ -~]/g, ""));
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnChange = (e) => {
        helper.setValue(e.target.value);
        helper.setTouched(e.target);
        field.onChange(e);
        charallow(e);
    };
    const getPattern = () => {
        switch (props.type) {
            case "wholeNumber":
                return "[0-9]*";
            case "wholeNumberAuth":
                return "[0-9]*";
            case "wholeNumberPayment":
                return "[0-9]*";
            case "bsb":
                return `/^\\s*\\d\\d\\d-?\\d\\d\\d\\s*$/`;
            default:
                return undefined;
        }
    };
    const getInputMode = () => {
        switch (props.type) {
            case "wholeNumber":
                return "numeric";
            case "wholeNumberAuth":
                return "numeric";
            case "wholeNumberPayment":
                return "numeric";
            case "bsb":
                return "numeric";
            default:
                return undefined;
        }
    };
    const getType = () => {
        switch (props.type) {
            case "password":
                return "password";
            default:
                return "text";
        }
    };
    const formProps = {
        className: inputClassName,
        id: fieldId,
        name: props.name,
        placeholder: props.placeHolder,
        disabled: props.disabled,
        "aria-describedby": helpTextId,
        pattern: getPattern(),
        inputMode: getInputMode(),
        type: getType(),
    };
    return (_jsxs("div", { className: "form-group", children: [props.type !== "checkbox" && (_jsx("label", { htmlFor: fieldId, children: props.label })), _jsxs("div", { className: "input-group", children: [props.type === "checkbox" && (_jsx(FormGroup, { children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { ...field }), label: props.label }) })), props.type === "currency" && (_jsx("div", { className: "input-group-prepend", children: _jsx("span", { className: "input-group-text", id: "validationTooltipUsernamePrepend", children: getCurrencySymbol() }) })), props.type === "currency" && (_jsx(NumericFormat, { ...formProps, thousandSeparator: true, allowLeadingZeros: false, allowNegative: false, decimalScale: 2, fixedDecimalScale: true, onValueChange: (x) => helper.setValue(x.floatValue), onBlur: () => helper.setTouched(true), value: field.value })), props.type === "wholeNumber" && (_jsx(NumericFormat, { ...formProps, allowLeadingZeros: true, allowNegative: false, decimalScale: 0, onValueChange: (x) => helper.setValue(x.floatValue), onBlur: () => helper.setTouched(true), value: field.value, maxLength: 15 })), props.type === "wholeNumberAuth" && (_jsx("input", { ...field, ...formProps, onChange: handleOnChange.bind(this), onBlur: handleOnChange.bind(this), value: field.value, maxLength: 15 })), props.type === "wholeNumberPayment" && (_jsx(NumericFormat, { ...formProps, allowLeadingZeros: false, allowNegative: false, decimalScale: 0, onValueChange: (x) => helper.setValue(x.floatValue), onBlur: () => helper.setTouched(true), value: field.value, maxLength: 5 })), (props.type === "text" || props.type === "password") &&
                        props.printableOnly !== true && (_jsx("input", { ...field, ...formProps })), (props.type === "text" || props.type === "password") &&
                        props.printableOnly === true && (_jsx("input", { ...field, ...formProps, onChange: handleOnChange.bind(this), onBlur: handleOnChange.bind(this), value: value })), props.type === "bsb" && (_jsx(PatternFormat, { ...field, ...formProps, format: "###-###", value: field.value, mask: "_" })), _jsx(FieldErrorMessage, { errorName: props.name })] }), _jsx("small", { id: helpTextId, className: "form-text text-muted", children: props.helpText })] }));
};
export default Input;
